module.exports = __webpack_public_path__ + "static/assets/6ba7baed8c9edc87ff698926ff148685.png";